import React, { Component } from 'react';
import './redeemed-vouchers.scss';

import Loading from '../../common/loading/loading';
import { ImageConstants } from '../../../constants/constants';
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component';
import { getImageSource } from '../../../utility/image-source'
import RewardApi from '../../../apis/rewards'


class Rewards extends Component {
    state = {
        loading: false,
        availablePoints: 250,
        vouchers: []
    }

    componentDidMount() {
        this.getVoucherHistory()
    }

    getVoucherHistory(payload = {}) {
        this.setState({ isLoading: true })
        RewardApi.getVoucherHistory(payload)
            .then(response => {
                let vouchers = response.response || []

                vouchers = vouchers.map(item => {
                    item.voucher.status = item.status
                    return item.voucher
                })
                this.setState({ vouchers, isLoading: false })
            }).catch(err => {
                this.setState({ isLoading: false })
            })
    }


    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 3000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }

    onClickInfo = () => {

        this.setState({ showRedeemInfo: !this.state.showRedeemInfo })
    }

    getImage(item) {
        if (this.state.availablePoints < item.point) return getImageSource(ImageConstants.ELLIPSE_INACTIVE)

        if (this.state.selectedVoucher === item._id) return getImageSource(ImageConstants.ELLIPSE_ACTIVE)

        return getImageSource(ImageConstants.ELLIPSE)
    }

    getCardColors(index) {
        let colors = ["grad-blue", "grad-red", "grad-yellow", "grad-green", "grad-orange"]

        if (index < 4) return colors[index]

        let value = index % 5

        return colors[value]

    }

    redeemPoints() {
        this.setState({})
        this.hideVoucherInfo()
    }

    showVoucherInfo(e, item) {
        this.setState({ showVoucherInfo: true, voucherInfo: item })
    }

    hideVoucherInfo = () => {
        this.setState({ showVoucherInfo: false, voucherInfo: null })
    }

    getStatusBackgroud(status) {
        if (status === "PENDING_FOR_APPROVAL" || status === "PURCHASED") return "bg-yellow"
        if (status === "REJECTED") return "bg-red"
        if (status === "DELIVERED") return "bg-green"
        return ""
    }


    getStatusText(status) {
        if (status === "PENDING_FOR_APPROVAL" || status === "PURCHASED") return "Pending for Approval"
        if (status === "REJECTED") return "Rejected"
        if (status === "DELIVERED") return "Delivered"
        return ""
    }

    renderVoucherCards() {
        return (
            <div className="">
                <div className="row">
                    {
                        this.state.vouchers?.length ?
                            this.state.vouchers.map((item, index) => (

                                <div className="col-12 mt-4">
                                    <div className={`cw-card `}>
                                        <div className={`status ${this.getStatusBackgroud(item.status)}`}>{this.getStatusText(item.status)}</div>
                                        <div className="row no-gutters">
                                            <div className="col-5">
                                                <div className={`voucher-card ${this.getCardColors(index)}`}>
                                                    <div className="image-wrapper">
                                                        <img alt="" className="image" src={item.image} />
                                                    </div>
                                                    <div className="detail-wrapper">
                                                        <div className="title ">{item.title}</div>
                                                        <div className="description">Worth {item.currency?.symbol} {item.price}</div>
                                                        <div className="pt-4"><span className="avail mr-2">Redeem </span><span className="point">{item.point} </span> points to get this voucher</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col p-4 my-auto">
                                                <div className="long-description">{item?.description}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                            :
                            <div className="col pt-4 text-center">No Records found</div>

                    }
                </div>

            </div>
        )
    }

    render() {
        return (
            <div className="redeemed-vouchers">
                {this.state.loading && <Loading />}

                <div className="pt-4">
                    <div ><img className='back-icon cursor-pointer' alt="" src={getImageSource(ImageConstants.BACK_ICON)} onClick={this.props.back} /></div>

                    <div className="row pt-4">
                        <div className="col">
                            <span className='screen-title'>Voucher Redeemed</span>
                            <div>You can check all your voucher requests here.</div>
                        </div>
                    </div>

                    <div className="pt-4">{this.renderVoucherCards()}</div>

                </div>

                {this.state.showToaster ? <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} /> : ""}
            </div>);
    }
}

export default Rewards;